import { GridColDef } from '@mui/x-data-grid';
import { StyledButton } from '../styled';
import { LiveTripsForSchool } from '../types';
import Icons from '../../../components/icons';

export const getLiveTripsColumns = (
  endTrip: (tripData: LiveTripsForSchool) => void,
  sosAlert: (tripData: LiveTripsForSchool) => void
): GridColDef[] => {
  return [
    { field: 'id', headerName: 'Id', flex: 1, minWidth: 80 },
    { field: 'No', headerName: 'No', flex: 1, minWidth: 120 },
    { field: 'Bus Name', headerName: 'Bus Name', flex: 1, minWidth: 120 },
    {
      field: 'License Plate',
      headerName: 'License Plate',
      flex: 1,
      minWidth: 120
    },
    { field: 'Stop', headerName: 'Stop', flex: 1, minWidth: 120 },
    { field: 'Last Action', headerName: 'Last Action', flex: 1, minWidth: 120 },
    {
      field: 'end trip',
      headerName: 'End Trip',
      flex: 1,
      minWidth: 120,
      headerAlign: 'center',
      align: 'center',
      renderCell: (params) => (
        <StyledButton onClick={() => endTrip(params.row)}>
          End Trip
        </StyledButton>
      )
    },
    {
      field: 'sos alert',
      headerName: 'SOS Alert',
      flex: 1,
      minWidth: 120,
      headerAlign: 'center',
      align: 'center',
      renderCell: (params) => (
        <StyledButton
          sx={{
            paddingLeft: '22px !important'
          }}
          onClick={() => sosAlert(params.row)}
          startIcon={<Icons.Alert />}
        >
          Send Alert
        </StyledButton>
      )
    }
  ];
};
